import React, { useState, useEffect } from "react";
import { Box, Grid, CircularProgress, Pagination, Container } from "@mui/material";
import axios from "../../../services/axios";
import Header from "../../../layout/Header";
import FooterComponent from "../../../layout/Footer";
import CardDestino from "./CardDestino";
import SearchBar from "./SearchBar";

const ListCatalogo = () => {
  const [destinos, setDestinos] = useState([]);
  const [itemsPorPagina] = useState(8);
  const [paginaActual, setPaginaActual] = useState(1);
  const [categoria, setCategoria] = useState("");
  const [filtro, setFiltro] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDestinos = async () => {
      try {
        const response = await axios.get("/destinos");
        setDestinos(response.data);
      } catch (error) {
        console.error("Error al obtener los destinos:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchDestinos();
  }, []);

  const destinosFiltrados = destinos
    .filter((destino) => (categoria ? destino.ciudad === categoria : true))
    .filter((destino) => destino.nombre.toLowerCase().includes(filtro.toLowerCase()));

  const totalPaginas = Math.ceil(destinosFiltrados.length / itemsPorPagina);

  const paginatedDestinos = () => {
    const inicio = (paginaActual - 1) * itemsPorPagina;
    const fin = inicio + itemsPorPagina;
    return destinosFiltrados.slice(inicio, fin);
  };

  const ciudadesUnicas = [...new Set(destinos.map((d) => d.ciudad))].sort();

  return (
    <Box display="flex" flexDirection="column" minHeight="100vh">
      <Header />
      <Box component="main" flexGrow={1}>
        <Container sx={{ mt: 4, mb: 4 }}>
          <SearchBar
            filtro={filtro}
            handleSearchChange={(e) => { setFiltro(e.target.value); setPaginaActual(1); }}
            categoria={categoria}
            handleCategoriaChange={(e) => { setCategoria(e.target.value); setPaginaActual(1); }}
            ciudadesUnicas={ciudadesUnicas}
          />

          <Box display="flex" justifyContent="center">
            {loading ? (
              <CircularProgress />
            ) : (
              <Grid container spacing={3} justifyContent="center">
                {paginatedDestinos().map((destino) => (
                  <Grid item xs={12} sm={6} md={4} lg={3} key={destino.id}>
                    <CardDestino destino={destino} />
                  </Grid>
                ))}
              </Grid>
            )}
          </Box>

          <Box display="flex" justifyContent="center" mt={4}>
            <Pagination
              count={totalPaginas}
              page={paginaActual}
              onChange={(e, value) => setPaginaActual(value)}
              color="primary"
            />
          </Box>
        </Container>
      </Box>
      <FooterComponent />
    </Box>
  );
};

export default ListCatalogo;
